import { message } from "antd";
import { client } from "../../../../../../actions";
import { authHeader } from "../../../../../../helpers/auth-header";
import downloadVoiting from "./downloadVoiting";
import { ErrorBrowser, NoContent } from "./voitingError";

function isFileUploadSupported() {
  return !!(window.File && window.FileReader && window.FormData);
}

const requestVoiting = async (setLoading, id) => {
  const uri = `/Voting/voting_report?votingId=${id}`;
  try {
    setLoading(true);
    const response = await client.get(uri, {
      headers: authHeader(),
    });
    if (response.status === 200) {
      const result = response.data;
      if (isFileUploadSupported()) {
        downloadVoiting(result.data, result.fileName);
        setLoading(false);
      } else {
        throw new ErrorBrowser('Настройки браузера не позволяют скачать результаты опроса');
      }
    }
    if(response.status === 204) {
      throw new NoContent('У вас нет доступа к данному опросу');
    }
      
  } catch (e) {
    setLoading(false);
    if(e.name === 'NoContent' || e.name === 'ErrorBrowser') {
      message.error(e.message);
    } else {
      message.error('Сервер недоступен, попробуйте позже');
    }
  }
};

export default requestVoiting;